import i18 from 'i18next';
import { PAGES } from '../pages';

export const metalStreamMenu = [
  {
    title: i18.t('createAccount'),
    checked: true,
  },
  {
    title: i18.t('metalstream.metalStream'),
    path: PAGES.METAL_STREAM_WELCOME,
    nextPath: PAGES.METAL_STREAM_MONTHLY_INVEST,
    previousPath: PAGES.METAL_STREAM,
    items: [
      {
        title: i18.t('metalstream.monthlyInvest'),
        path: PAGES.METAL_STREAM_MONTHLY_INVEST,
        nextPath: PAGES.METAL_STREAM_FUND_ALLOCATION,
        previousPath: PAGES.METAL_STREAM_WELCOME,
      },
      {
        title: i18.t('metalstream.allocation'),
        path: PAGES.METAL_STREAM_FUND_ALLOCATION,
        nextPath: PAGES.METAL_STREAM_GOLD,
        previousPath: PAGES.METAL_STREAM_MONTHLY_INVEST,
      },
      {
        title: i18.t('metalstream.gold'),
        path: PAGES.METAL_STREAM_GOLD,
        nextPath: PAGES.METAL_STREAM_SILVER,
        previousPath: PAGES.METAL_STREAM_FUND_ALLOCATION,
        skipPath: PAGES.METAL_STREAM_SILVER,
      },
      {
        title: i18.t('metalstream.silver'),
        path: PAGES.METAL_STREAM_SILVER,
        nextPath: PAGES.FUNDING.METALSTREAM_FUNDING.ACCOUNT,
        skipPath: PAGES.FUNDING.METALSTREAM_FUNDING.ACCOUNT,
        preSkipPath: PAGES.METAL_STREAM_FUND_ALLOCATION,
        previousPath: PAGES.METAL_STREAM_GOLD,
      },
      {
        title: i18.t('fund'),
        path: PAGES.FUNDING.METALSTREAM_FUNDING.ACCOUNT,
        nextPath: PAGES.METAL_STREAM_REVIEW,
        skipPath: PAGES.METAL_STREAM_REVIEW,
        preSkipPath: PAGES.METAL_STREAM_GOLD,
        previousPath: PAGES.METAL_STREAM_SILVER,
      },
      {
        title: i18.t('metalstream.review'),
        path: PAGES.METAL_STREAM_REVIEW,
        nextPath: PAGES.METAL_STREAM_SUMMARY,
        previousPath: PAGES.FUNDING.METALSTREAM_FUNDING.ACCOUNT,
      },
      {
        title: i18.t('metalstream.complete'),
        path: PAGES.METAL_STREAM_SUMMARY,
        nextPath: PAGES.SECURE_ACCOUNT,
        previousPath: PAGES.METAL_STREAM_REVIEW,
      },
    ],
  },
  {
    title: i18.t('secureAccount'),
    path: PAGES.SECURE_ACCOUNT,
    nextPath: PAGES.SECURE_NAME,
    previousPath: PAGES.METAL_STREAM_SUMMARY,
    items: [
      {
        title: i18.t('name'),
        previousPath: PAGES.SECURE_ACCOUNT,
        path: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_DOB,
      },
      {
        title: i18.t('dob'),
        previousPath: PAGES.SECURE_NAME,
        path: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY,
      },
      {
        title: i18.t('identityVerification'),
        path: PAGES.SECURE_IDENTITY,
        previousPath: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY_SSN,
        skipPath: PAGES.SECURE_PHONE_NUMBER,
        items: [
          {
            previousPath: PAGES.SECURE_IDENTITY,
            path: PAGES.SECURE_IDENTITY_SSN,
            nextPath: PAGES.SECURE_IDENTITY_IRS,
          },
          {
            previousPath: PAGES.SECURE_IDENTITY_SSN,
            path: PAGES.SECURE_IDENTITY_IRS,
            nextPath: PAGES.SECURE_PHONE_NUMBER,
          },
        ],
      },
      {
        title: i18.t('phoneNumber'),
        path: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_IDENTITY_IRS,
        preSkipPath: PAGES.SECURE_IDENTITY,
        nextPath: PAGES.ADDRESS,
      },
    ],
  },
  {
    title: i18.t('address'),
    path: PAGES.ADDRESS,
    nextPath: PAGES.ADDRESS_ENTER,
    previousPath: PAGES.SECURE_PHONE_NUMBER,
    preSkipPath: PAGES.SECURE_IDENTITY,
    items: [
      {
        path: PAGES.ADDRESS_ENTER,
        nextPath: PAGES.ADDRESS_DONE,
        previousPath: PAGES.ADDRESS,
      },
      {
        path: PAGES.ADDRESS_DONE,
        nextPath: PAGES.METAL_SECURE_ACCOUNT.REVIEW,
        previousPath: PAGES.ADDRESS_ENTER,
      },
    ],
  },
  {
    title: i18.t('review'),
    path: PAGES.METAL_SECURE_ACCOUNT.REVIEW,
    nextPath: PAGES.METAL_SECURE_ACCOUNT.AGREEMENT,
    previousPath: PAGES.ADDRESS_DONE,
    preSkipPath: PAGES.ADDRESS_DONE,
    items: [
      {
        path: PAGES.METAL_SECURE_ACCOUNT.AGREEMENT,
        nextPath: '/',
        previousPath: PAGES.METAL_SECURE_ACCOUNT.REVIEW,
      },
    ],
  },
];
